import { render, staticRenderFns } from "./UpgratePlanModal.vue?vue&type=template&id=5e869631&scoped=true"
import script from "./UpgratePlanModal.vue?vue&type=script&lang=js"
export * from "./UpgratePlanModal.vue?vue&type=script&lang=js"
import style0 from "./UpgratePlanModal.vue?vue&type=style&index=0&id=5e869631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e869631",
  null
  
)

export default component.exports